import React, { useState, useEffect } from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import Button from "../../../../Elements/Button/Button.js";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import { useModal } from "../../../../../contexts/modalContext/modalContext.js";
import { useUser } from "../../../../../contexts/userContext/userContext.js";

const AddPaypalAccountModal = ({
  editDetails,
  isEdit = false,
  paypalAccounts,
  setPaypalAccounts,
  index,
}) => {
  const { getUserData } = useUser();
  const userData = getUserData();
  const { closeModal } = useModal();
  const { getTextByKey } = useContent();
  const [paypalOwner, setPaypalOwner] = useState("");
  const [paypalEmail, setPaypalEmail] = useState("");
  useEffect(() => {
    if (isEdit) {
      setPaypalOwner(editDetails.AccountOwnerName);
      setPaypalEmail(editDetails.AccountEmail);
    }
  }, [isEdit]);

  const handleSubmit = () => {
    let body = {
      entryId: isEdit ? Number(index) : 0,
      delete: false,
      AccountOwnerName: paypalOwner,
      AccountEmail: paypalEmail,
    };
    addBankToApi(body);
  };

  const addBankToApi = async (body) => {
    const response = await apiRequest(
      "Users",
      "SetPaypalAccountDetailsReact",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
        let newPaypalAccounts = [...paypalAccounts];
        if (isEdit) {
          //replace old paypal account with new one by item.keyIndex prop
          const listIndex = newPaypalAccounts.indexOf(
            newPaypalAccounts.find((item) => item.keyIndex === index)
          );
          newPaypalAccounts[listIndex] = body;
        } else {
          let newPaypal = {
            AccountEmail: paypalEmail,
            AccountOwnerName: paypalOwner,
          };
          let lastPaypal = newPaypalAccounts[newPaypalAccounts.length - 1];
          if (lastPaypal) {
            newPaypal.keyIndex = Number(lastPaypal.keyIndex) + 1;
          } else {
            newPaypal.keyIndex = 1;
          }
          newPaypalAccounts.push(newPaypal);
        }
        setPaypalAccounts(newPaypalAccounts);
        closeModal();
      }
    }
  };

  return (
    <div className="add-paypal-account-modal">
      <div className="add-bank-modal-header">
        <h3>
          {getTextByKey(isEdit ? "edit-paypal-account" : "add-paypal-account")}
        </h3>
      </div>
      <div className="add-bank-modal-content">
        <div className="add-bank-modal-input-container">
          <div className="input-div account-owner">
            <span className="input-span">{getTextByKey("account-owner")}</span>
            <input
              type="text"
              value={paypalOwner}
              onChange={(e) => setPaypalOwner(e.target.value)}
            />
          </div>
          <div className="input-div account-owner">
            <span className="input-span">{getTextByKey("account-email")}</span>
            <input
              type="text"
              value={paypalEmail}
              onChange={(e) => setPaypalEmail(e.target.value)}
            />
          </div>
        </div>
        <div className="submit-container">
          <Button onClick={() => handleSubmit()}>{getTextByKey("ok")}</Button>
        </div>
      </div>
    </div>
  );
};

export default AddPaypalAccountModal;
